let store = require('redux').createStore(require('./retailer.student.reducer.js'),
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
function createAction(type, payload) {
	return {type, payload};
}
function dispatch(type, payload) {
	store.dispatch(createAction(type, payload));
}
module.exports = {
	store, createAction, dispatch
}


// WEBPACK FOOTER //
// ../public/js/retailer.student.store.js